import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import VenueForm from "../VenueForm";

import { useVenueEditForm } from "./hooks";

const VenueEdit = () => {
  const form = useVenueEditForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Edit venue" />
        </Typography.Title>
      </Header>
      <Space />
      <VenueForm {...form} />
    </>
  );
};

export default VenueEdit;
